import React, { useEffect, useState } from 'react';
import Video from '../Video/Video';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { message, Modal, Spin } from 'antd';
import { getSessionById } from '../../redux/features/sessions/sessionActions';
import axios from 'axios';
import {
  PrivateAxiosInstance,
  publicAxiosInstance,
} from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import YoutubePlayer from '../YoutubePlayer/YoutubePlayer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';
import { BsCollectionPlayFill } from 'react-icons/bs';
import CollectionTitleCard from '../CollectionTitleCard/CollectionTitleCard';
import Card from '../Card/Card';

function VideoCard() {
  const [isFulled, setIsFull] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sessionData, setSessionData] = useState(null);
  const [isRegi, setIsRegi] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [isUplaodVideoOrLink, setIsUplaodVideoOrLink] = useState(false);
  const [collectionData, setColectionData] = useState('');
  // const [colletionName, setCollectionName] = useState('');

  const { id, type } = useParams(); // Get session ID from URL parameters
  const dispatch = useDispatch();

  const fetchSessionData = async () => {
    setLoading(true);
    try {
      const res = await dispatch(getSessionById({ eventId: id })).unwrap();
      const sessionData = res?.event; // Extract event data
      setIsComplete(sessionData?.event_status === 'complete' ? true : false);
      setIsUplaodVideoOrLink(sessionData?.video?.length > 0 ? true : false);
      setSessionData(sessionData);
      await fetchCollectionById(sessionData?.eventCollectionId);
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to fetch session';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkRegistration();
    fetchSessionData();
    isVerifyCheck();
  }, [dispatch, id]);

  const isVerifyCheck = async () => {
    setLoading(true);
    let verifyStatus;
    const res = await PrivateAxiosInstance.get(URLs.CHECK_USER_VERIFIED_URL);
    verifyStatus = res.data?.user?.['custom:Verify'];

    if (verifyStatus != 'verified') {
      setIsVerify(false);
    } else {
      setIsVerify(true);
    }
    setLoading(false);
  };

  const { isAuthenticated, rl, uid, verify } = useSelector(
    (state) => state.auth
  );
  const role = decryptData(rl);
  const userId = decryptData(uid);

  const checkRegistration = async () => {
    setLoading(true);
    try {
      const url = `${URLs.GET_REGISTER_SESSION_DETAILS_URL}?search=${id}`; // search by event id

      const res = await PrivateAxiosInstance.get(url); //api call
      const data = res?.data?.events;
      if (data.length > 0) {
        const filterUserisRegi = data.filter(
          (event) => event?.userId === userId
        ); // filter by user id

        if (filterUserisRegi.length > 0) {
          setIsRegi(true); // set isRegi to true if user is registered
        } else {
          setIsRegi(false); // set isRegi to false if user is not registered
        }
      } else {
        // message.error('No events data found');
      }
    } catch (err) {
      message.error('Something went wrong during fetching events data');
    } finally {
      setLoading(false);
    }
  };

  const handleJoinToSession = async () => {
    setLoading(true);
    if (role === 'admin' || role === 'editor') {
      message.warning(`You are ${role} user, you can not join to session!`);
      setLoading(false);
      return;
    }

    try {
      let isVerify;

      try {
        const res = await PrivateAxiosInstance.get(
          URLs.CHECK_USER_VERIFIED_URL
        );
        isVerify = res?.data?.user?.['custom:Verify'];
      } catch (error) {
        // const errorMessage = await handleApiError(error)
        setLoading(false);
        message.error('Failed to join session');
      }

      if (isVerify != 'verified') {
        message.warning(
          'Account is not verified. Please check your email and verify your account'
        );
        setLoading(false);
        return;
      }

      try {
        await PrivateAxiosInstance.post(
          URLs.JOIN_SESSION_URL.replace(':eventId', id)
        );
        message.success('Successfully joined session');
        fetchSessionData();
        setIsRegi(true);
      } catch (error) {
        message.error(error?.response?.data?.message);
        setLoading(false);
      }
    } catch (error) {
      message.error('Failed to join session');
    } finally {
      setLoading(false);
    }
  };

  const handleUnJoinToSession = async () => {
    setLoading(true);
    if (role === 'admin' || role === 'editor') {
      message.warning(`You are ${role} user, you can not unenroll to session!`);
      setLoading(false);
      return;
    }
    try {
      await PrivateAxiosInstance.delete(
        URLs.DELETE_REGISTER_SESSION_URL.replace(':eventId', id)
      );
      fetchSessionData();
      message.success('Unregistered successfully');
      setIsRegi(false);
    } catch (err) {
      message.error(err?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCollectionById = async (eventCollectionId) => {
    if (!eventCollectionId) return;
    try {
      const url = `${URLs.GET_BY_SINGlE_COLLECTION}/${eventCollectionId}`;
      const res = await publicAxiosInstance.get(url);

      const data = res?.data?.event;

      setColectionData(data);
    } catch (err) {
      message.error('Something went wrong during fetching Collection data');
    } finally {
      // setGetLoading(false)
    }
  };

  const showConfirm = () => {
    Modal.confirm({
      title: 'Enroll Session',
      content: 'Are you sure you want to enroll this session?',
      okText: 'Yes',
      cancelText: 'Cancel',
      onOk() {
        handleJoinToSession();
      },
    });
  };

  const unenroll = () => {
    Modal.confirm({
      title: 'Unenroll Session',
      content: 'Are you sure you want to unenroll this session?',
      okText: 'Yes, No',
      cancelText: 'Cancel',
      onOk() {
        handleUnJoinToSession();
      },
    });
  };

  return (
    <>
      {loading ? (
        <Spin tip="Loading..." spinning={loading} fullscreen />
      ) : (
        <div className="flex flex-col rounded-lg overflow-hidden  mx-auto mt-[10px] lg:mt-[50px] mb-5 lg:p-10">
          {sessionData?.isCollection && (
            <div className="m-5">
              <CollectionTitleCard
                title={collectionData.eventCollectionName || 'No Collection'}
              />
            </div>
          )}

          {/* Video */}
          {!isComplete ? (
            <div className="w-full aspect-w-16 aspect-h-8 lg:h-full  rounded-lg">
              {sessionData?.coverImage[0]?.url ? (
                <img
                  src={sessionData?.coverImage[0]?.url}
                  alt={sessionData?.event_name || 'Unknown'}
                  className="h-full w-full object-container object-center  "
                />
              ) : (
                <div className="h-[280px] mt-[165px] w-full flex items-center justify-center bg-gray-300 rounded-lg">
                  <p className="text-gray-500">No Content available</p>
                </div>
              )}
            </div>
          ) : (
            <div className="w-full aspect-w-16 aspect-h-8 rounded-lg">
              {sessionData?.video && sessionData.video.length > 0 ? (
                // Pass the URL to Video component if it's not a YouTube video
                sessionData.video[0].videoName !== 'YouTube' ? (
                  <Video videoSrc={sessionData.video || []} />
                ) : (
                  // <Video />
                  // Use YoutubePlayer component for YouTube videos
                  <YoutubePlayer youtubeUrl={sessionData.video[0].url} />
                )
              ) : (
                <div className="w-full aspect-w-16 aspect-h-8 lg:h-[460px]  rounded-lg">
                  {sessionData?.coverImage[0]?.url ? (
                    <img
                      src={sessionData?.coverImage[0]?.url}
                      alt={sessionData?.event_name || 'Unknown'}
                      className="h-full w-full object-container object-top  "
                    />
                  ) : (
                    <div className="h-[280px] mt-[165px] w-full flex items-center justify-center bg-gray-300 rounded-lg">
                      <p className="text-gray-500">No Content available</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Video meta data*/}
          <div className="p-6 flex justify-between items-center bg-background-secondary-color ">
            <div className="flex-grow">
              {isVerify && isComplete && !isUplaodVideoOrLink && (
                <p className=" text-paragraph-font-size font-normal text-red-500 font-poppins leading-relaxed mb-2">
                  No video upload yet
                </p>
              )}

              <div className="flex flex-inline gap-1 mb-1">
                {collectionData?.length > 0 && (
                  <div className="flex flex-inline gap-1">
                    <BsCollectionPlayFill className="text-green-600 mt-1" />
                    <p class="flex text-green-600 capitalize font-poppins  text-sm">
                      {collectionData.eventCollectionName}
                    </p>
                  </div>
                )}
              </div>

              <h3 className="text-lg md:text-2xl font-bold text-gray-300 font-poppins mt-3 mb-3">
                {sessionData?.event_name || 'Unknown'}
              </h3>

              <h5 className="text-btn-color text-paragraph-font-size font-medium capitalize font-poppins">
                {sessionData?.presenter || 'Unknown'}
              </h5>

              <p className=" text-paragraph-font-size font-semibold text-text-paragraph-color font-poppins leading-relaxed mt-1">
                Language:{' '}
                <span className="text-paragraph-font-size font-medium">
                  {' '}
                  {sessionData?.medium || 'No Data'}
                </span>
              </p>

              <p className=" text-paragraph-font-size font-semibold text-text-paragraph-color font-poppins leading-relaxed mt-1">
                Date:{' '}
                <span className="text-paragraph-font-size font-medium">
                  {' '}
                  {sessionData?.date
                    ? new Date(sessionData.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        timeZoneName: 'short',
                      })
                    : 'No Data'}
                </span>
              </p>

              <p className=" text-paragraph-font-size font-semibold text-text-paragraph-color font-poppins leading-relaxed mt-1">
                Start:{' '}
                <span className="text-paragraph-font-size font-medium">
                  {' '}
                  {sessionData?.startTime || 'No Data'}
                </span>
              </p>

              <p className=" text-paragraph-font-size font-semibold text-text-paragraph-color font-poppins leading-relaxed mt-1">
                End:{' '}
                <span className="text-paragraph-font-size font-medium">
                  {sessionData?.endTime || 'No Data'}
                </span>
              </p>

              {!isComplete && (
                <>
                  <p className="text-paragraph-font-size font-semibold text-text-paragraph-color font-poppins leading-relaxed mt-1">
                    Available Seats:
                    <span className="text-text-paragraph-color font-poppins font-medium text-paragraph-font-size ml-1">
                      {/* Check if seatsAvailable is 0 */}
                      {sessionData?.seatsAvailable === 0
                        ? 'Not Available'
                        : sessionData?.numOfSeats || 'No Data'}
                    </span>
                  </p>

                  {/* BUG: need to add a link to the session */}
                  <p className=" text-paragraph-font-size font-medium text-text-paragraph-color font-poppins leading-relaxed mt-1 flex items-center">
                    <span className="text-paragraph-font-size font-semibold">
                      Session URL:&nbsp;
                    </span>
                    {isVerify && isRegi ? (
                      <>
                        {sessionData?.zoomLink ? (
                          <>
                            {/* Render as a clickable link */}
                            <a
                              href={sessionData?.zoomLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 underline hover:text-blue-700"
                            >
                              {sessionData?.zoomLink}
                            </a>
                          </>
                        ) : (
                          'No session URL added yet'
                        )}
                      </>
                    ) : (
                      'You are not register or verify to view this session link'
                    )}
                  </p>
                </>
              )}

              <p className=" mt-2  text-paragraph-font-size font-medium whitespace-pre-line text-text-paragraph-color font-poppins leading-relaxed">
                {sessionData?.description?.split(' ').slice(0, 2000).join(' ') +
                  '...' || 'No Description'}
              </p>

              {!isComplete && ( //true
                <>
                  {!isRegi && (
                    <div className="flex justify-end font-poppins space-x-4 space-y-4 text-center mb-5 mt-5 md:mr-20">
                      <button
                        type="button"
                        onClick={showConfirm}
                        className="px-8 py-2.5 rounded-lg text-black font-bold tracking-wider curser-pointer transition-all duration-300 hover:bg-btn-hover-color bg-btn-color   curser-pointer "
                      >
                        Enroll
                      </button>
                    </div>
                  )}

                  {isRegi && (
                    <div className="flex justify-end font-poppins space-x-4 space-y-4 text-center mb-5 mt-5 md:mr-5">
                      <button
                        type="button"
                        onClick={unenroll}
                        className="px-8 py-2.5 rounded-lg text-white font-bold tracking-wider curser-pointer transition-all duration-300 hover:bg-gray-400 bg-gray-500   curser-pointer "
                      >
                        Unregister
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
            <div></div>
          </div>

          {/* <SessionCard /> */}
          {sessionData?.isCollection && (
            <div className="mt-5">
              <Card data={collectionData} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default VideoCard;
